import { Button, List, ListSubheader, Paper } from "@mui/material";
import { WithStyles } from "@mui/styles";
import withStyles from "@mui/styles/withStyles";
import { AppState } from "AppState";
import { Cluster } from "pages/management/cluster/types";
import ClusterItemComponent from "pages/management/treeView/clusterItem/ClusterItemComponent";
import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { styles } from "pages/management/treeView/styles";
import { clusterCreateWizardShow } from "pages/management/cluster/clusterCreateWizard/actions";
import NoClusterItemComponent from "pages/management/treeView/clusterItem/NoClusterItemComponent";

// PROPS
interface LocalProps {
	clusterList: Cluster[];
}

interface ReduxProps {
	clusterCreateDialogShow: () => void;
}

// component local state interface
interface State {}

type Props = LocalProps &
	ReduxProps &
	WithStyles<typeof styles> &
	RouteComponentProps<{}>;

// COMPONENT
class TreeViewComponent extends React.Component<Props, State> {
	render(): React.ReactNode {
		const { clusterList } = this.props;

		return (
			<>
				<Paper data-testid="tree-view" className={this.props.classes.root}>
					<List subheader={<ListSubheader>Managed clusters</ListSubheader>}>
						{clusterList.length > 0 ? (
							clusterList
								.sort((cluster1: Cluster, cluster2: Cluster) =>
									cluster1.name
										.toLowerCase()
										.localeCompare(cluster2.name.toLowerCase())
								)
								.map((cluster: Cluster) => {
									return (
										<ClusterItemComponent
											data-testid="tree-view-cluster"
											key={cluster.id}
											clusterID={cluster.id || -1}
										/>
									);
								})
						) : (
							<NoClusterItemComponent data-testid="tree-view-empty" />
						)}
					</List>
				</Paper>
				<Button
					data-testid="cluster-create-button"
					fullWidth={true}
					onClick={() => {
						this.props.clusterCreateDialogShow();
					}}
				>
					Add cluster
				</Button>
			</>
		);
	}
}

// REDUX MAPPINGS
const mapGlobalStateToProps = (state: AppState) => {
	return {
		clusterList: state.clusterList
	};
};

const mapGlobalDispatchToProps = (dispatch: any) => ({
	clusterCreateDialogShow: () => {
		dispatch(clusterCreateWizardShow());
	}
});

export default withStyles(styles)(
	connect(mapGlobalStateToProps, mapGlobalDispatchToProps)(TreeViewComponent)
);
